import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      class: "fill",
      d: "M16.3028 4.303C16.5242 4.07378 16.789 3.89094 17.0818 3.76516C17.3746 3.63938 17.6896 3.57317 18.0082 3.5704C18.3269 3.56763 18.6429 3.62836 18.9379 3.74903C19.2328 3.86971 19.5008 4.04791 19.7262 4.27326C19.9515 4.4986 20.1297 4.76656 20.2504 5.06151C20.3711 5.35647 20.4318 5.6725 20.429 5.99117C20.4262 6.30984 20.36 6.62477 20.2343 6.91758C20.1085 7.21039 19.9256 7.47521 19.6964 7.6966L18.7448 8.6482L15.3512 5.2546L16.3028 4.303ZM13.6544 6.95141L3.59961 17.0062V20.3998H6.99321L17.0492 10.345L13.6532 6.95141H13.6544Z",
      fill: "#212225"
    }, null, -1)
  ])))
}
export default { render: render }